import React, { useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../App.scss';
const Callback = () => {
  const { updateUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const { search } = window.location;
      const code = new URLSearchParams(search).get('code');

      if (code) {
        try {
          const response = await axios.get(`/api/auth/discord/callback?code=${code}`);
          // Store JWT token to Local Storage
          const token = response.data.token;
          localStorage.setItem('isha_token', token);

          // Update user state in context
          await updateUser();

          // After getting response, redirect user to home page or dashboard
          navigate('/');
        } catch (error) {
          console.error('Error during Discord OAuth callback:', error);
          navigate('/login');
        }
      } else {
        // No code in the URL, redirect to login page
        navigate('/login');
      }
    };

    fetchUser();
  }, [updateUser, navigate]); // Include `updateUser` and `navigate` in dependencies array

  return (
    <div>
      <p>Loading...</p>
    </div>
  );
};

export default Callback;
